/* eslint no-console: "off" */
export default message => {
  if (process.env.NODE_ENV === 'development') {
    console.debug(message)
  }
}
